<template>
  <div class="report-main">
    <div class="topBox">
      <img src="../../../static/img/UNIFI_LOGO.png" alt="" class="report-logo" />
    </div>
    <div class="report-content">
      <div class="pdf-tit center-box">Property Campaign Report</div>
      <div class="pdf-time center-box">{{ pdfTimeShow ? `(${pdfTimeShow})` : '-'
        }}
      </div>
      <div class="property-infoBox">
        <div class="property-imgBox">
          <img crossorigin="anonymous" :src="`${propertyPdfInfo.propertyImg}?time=${new Date().getTime()}`"
            class="property-imgBox" alt="">
          <img crossorigin="anonymous" :src="`${propertyPdfInfo.houseInfo.companyLogoUrl}?time=${new Date().getTime()}`"
            class="property-icon" />
        </div>
        <div class="property-info">
          <p class="property-type">{{ propertyPdfInfo.housePropertyInfoPojo.proertyType ?
            propertyPdfInfo.housePropertyInfoPojo.proertyType : 'House & Land' }}</p>
          <p class="addressText">
            {{ propertyPdfInfo.houseInfo.address ? `${propertyPdfInfo.houseInfo.address}, ` : '' }} {{
              propertyPdfInfo.houseInfo.suburb }} {{
              propertyPdfInfo.houseInfo.state }} {{
              propertyPdfInfo.houseInfo.postcode }}
          </p>
          <p class="primaryText" style="font-size: 20px">${{ propertyPdfInfo.houseInfo.price }} {{
            propertyPdfInfo.houseInfo.maxPrice ? `- $${propertyPdfInfo.houseInfo.maxPrice}` : '' }}</p>
          <div class="lineBox" style="margin: 15px 0"></div>
          <!-- type1 -->
          <div v-if="propertyPdfInfo.housePropertyInfoPojo.proertyType !== 'Land'" class="house-info">
            <div class="flex-box housevalueBox">
              <span class="label-box primaryText">Estimated Commencement</span>
              <span class="value-box primaryText">{{ propertyPdfInfo.houseInfo.estimatedCommenceMent
                ? propertyPdfInfo.houseInfo.estimatedCommenceMent : '-' }}</span>
            </div>
            <div class="flex-box housevalueBox">
              <span class="label-box primaryText">Estimated Completion</span>
              <span class="value-box primaryText">{{ propertyPdfInfo.houseInfo.estimatedCompletion
                ? propertyPdfInfo.houseInfo.estimatedCompletion : '-' }}</span>
            </div>
            <div class="flex-box housevalueBox">
              <span class="label-box primaryText">Contract Type</span>
              <span class="value-box primaryText">{{ propertyPdfInfo.houseInfo.contractType
                ? propertyPdfInfo.houseInfo.contractType : '-' }}</span>
            </div>
            <div class="flex-box housevalueBox">
              <span class="label-box primaryText">Estimated Rental (per week)</span>
              <span class="value-box primaryText">${{ propertyPdfInfo.houseInfo.rental
                ? propertyPdfInfo.houseInfo.rental : '0' }} - ${{
                  propertyPdfInfo.houseInfo.maxRental
                    ? propertyPdfInfo.houseInfo.maxRental : '0' }}</span>
            </div>
            <div class="flex-box housevalueBox">
              <span class="label-box primaryText">Incentives</span>
              <span class="value-box primaryText">{{ propertyPdfInfo.houseInfo.incentives
                ? propertyPdfInfo.houseInfo.incentives : '-' }}</span>
            </div>
          </div>
          <!-- type2 -->
          <div class="house-info" v-else>
            <div class="flex-box housevalueBox">
              <span class="label-box primaryText">Estimated Settlement</span>
              <span class="value-box primaryText">{{ propertyPdfInfo.houseInfo.estimatedSettled
                ? propertyPdfInfo.houseInfo.estimatedSettled : '-' }}</span>
            </div>
            <div class="flex-box housevalueBox">
              <span class="label-box primaryText">Titles Iessued</span>
              <span class="value-box primaryText">{{ propertyPdfInfo.houseInfo.titlesIssued
                ? propertyPdfInfo.houseInfo.titlesIssued : '-' }}</span>
            </div>
            <div class="flex-box housevalueBox">
              <span class="label-box primaryText">Land Size</span>
              <span class="value-box primaryText">{{ propertyPdfInfo.houseInfo.labdSize
                ? propertyPdfInfo.houseInfo.labdSize : '0' }}m² {{ propertyPdfInfo.houseInfo.landSizeMax
                  ? `- ${propertyPdfInfo.houseInfo.landSizeMax}m²` : '' }}</span>
            </div>
            <div class="flex-box housevalueBox">
              <span class="label-box primaryText">Contract Type</span>
              <span class="value-box primaryText">{{ propertyPdfInfo.houseInfo.contractType
                ? propertyPdfInfo.houseInfo.contractType : '-' }}</span>
            </div>
            <div class="flex-box housevalueBox">
              <span class="label-box primaryText">Incentives</span>
              <span class="value-box primaryText">{{ propertyPdfInfo.houseInfo.incentives
                ? propertyPdfInfo.houseInfo.incentives : '-' }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="lineBox" style="margin: 40px 0"></div>
      <div class="broker-list">
        <div class="broker-item" v-for="(item, i) in propertyPdfInfo.agentList" :key="i">
          <img crossorigin="anonymous" :src="`${item.agentImageUrl1}?time=${Date.now()}`" class="userImg" alt="" />
          <div>
            <img crossorigin="anonymous" class="user-icon"
              :src="`${propertyPdfInfo.houseInfo.companyLogoUrl}?time=${Date.now()}`" />
            <div class="user-name">{{ item.agentFirstName1 }} {{ item.agentLastName1 }}</div>
            <div class="primaryText">{{ item.agentMobile1 }}</div>
          </div>
        </div>
      </div>
      <div class="lineBox" style="margin:0 0 40px 0"></div>
      <div class="statistics-list">
        <div class="statistics-card">
          <div class="sta-label">Views</div>
          <div class="num-box">{{ propertyPdfInfo.actionsLogStatics.views }}</div>
        </div>
        <div class="statistics-card">
          <div class="sta-label">Search Results</div>
          <div class="num-box">{{ propertyPdfInfo.actionsLogStatics.searchResults }}</div>
        </div>
        <div class="statistics-card">
          <div class="sta-label">Details Clicks</div>
          <div class="num-box">{{ propertyPdfInfo.actionsLogStatics.detailsClicks }}</div>
        </div>
        <div class="statistics-card">
          <div class="sta-label">Time on Page</div>
          <div class="num-box">{{ propertyPdfInfo.actionsLogStatics.timeOnPage }}
            {{ propertyPdfInfo.actionsLogStatics.timeOnPage > 1 ? 'mins' : 'min' }}</div>
        </div>
        <div class="statistics-card">
          <div class="sta-label">Select Now Clicks</div>
          <div class="num-box">{{ propertyPdfInfo.actionsLogStatics.selectNowClicks }}</div>
        </div>
        <div class="statistics-card">
          <div class="sta-label">Phone Clicks</div>
          <div class="num-box">{{ propertyPdfInfo.actionsLogStatics.phoneClicks }}</div>
        </div>
        <div class="statistics-card">
          <div class="sta-label">Favourited</div>
          <div class="num-box">{{ propertyPdfInfo.actionsLogStatics.favourited }}</div>
        </div>
        <div class="statistics-card">
          <div class="sta-label">Shares</div>
          <div class="num-box">{{ propertyPdfInfo.actionsLogStatics.shares }}</div>
        </div>
      </div>
      <div class="lineBox" style="margin:0 0 40px 0"></div>
      <div class="line-chart">
        <div class="chart-tip">Views</div>
        <div id="line-chart"></div>
      </div>
      <div class="lineBox" style="margin: 40px 0"></div>
      <div class="flex-box" style="justify-content:space-between;">
        <div class="bar-box">
          <div class="chart-tip">Tab Views</div>
          <div id="bar-chart"
            :style="{ height: this.propertyPdfInfo.tabViewStaticsLength ? this.propertyPdfInfo.tabViewStaticsLength * 55 + 'px' : 'auto' }"
            v-show="this.propertyPdfInfo.tabBarXData.length"></div>
          <div class="empty-text" v-show="!this.propertyPdfInfo.tabBarXData.length">No data yet</div>
        </div>
        <div class="bar-box">
          <div class="chart-tip">Time on Tab</div>
          <div id="bar-chartTwo"
            :style="{ height: this.propertyPdfInfo.timeOnTabLength ? this.propertyPdfInfo.timeOnTabLength * 55 + 'px' : 'auto' }"
            v-show="this.propertyPdfInfo.tabBarXData1.length"></div>
          <div class="empty-text" v-show="!this.propertyPdfInfo.tabBarXData1.length">No data yet</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as echarts from "echarts";
export default {
  data() {
    return {
      time: '',
    }
  },
  props: {
    pdfTimeShow: {
      type: String,
      default: ""
    },
    propertyPdfInfo: {
      type: Object,
      default: {
        houseInfo: {
          companyLogoUrl: ''
        }
      }
    }
  },
  watch: {
    pdfTimeShow: {
      handler(nv) {
        this.time = nv
        console.log(this.time + '11111111');
      }
    }
  },
  methods: {
    initLineChart(id, xData, yData) {
      const myChartNow = echarts.init(
        document.getElementById(id ? id : "line-chart"),
        "",
        { devicePixelRatio: 2 }
      );
      const series = [
        {
          name: "line-title-new",
          data: yData,
          type: "line",
          smooth: true,
          itemStyle: {
            normal: {
              color: "#02B08E"
            }
          },
          lineStyle: {
            color: "#02B08E",
            width: 1
          }
        }
      ];
      const option = {
        grid: {
          left: "0%",
          right: "1%",
          bottom: "2%",
          top: "8%",
          containLabel: true
        },
        animation: false,
        xAxis: {
          data: xData,
          type: "category",
          axisTick: {
            show: false
          },
          axisLabel: {
            textStyle: {
              color: "#101010",
              fontSize: "14px",
              fontFamily: "Metropolis"
            },
            interval: "auto"
          },
          axisLine: {
            lineStyle: {
              color: "#EAEAEA"
            }
          }
        },
        yAxis: {
          type: "value",
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            textStyle: {
              position: "inside",
              color: "#101010",
              fontSize: "14px",
              fontFamily: "Metropolis"
            }
          },
          splitLine: {
            interval: 60,
            show: true,
            lineStyle: {
              width: 1,
              type: "solid",
              color: "#EAEAEA"
            }
          }
        },
        series: [...series],
        tooltip: {
          show: false,
          trigger: "axis",
          textStyle: {
            color: "#505D6F",
            fontSize: "12",
            fontFamily: "Metropolis"
          },
          extraCssText:
            "border-radius:4px;width:268px;padding:8px;background:#F8F8F8;border-color:#F8F8F8;"
        }
      };
      document
        .getElementById(id ? id : "line-chart")
        .removeAttribute("_echarts_instance_");
      myChartNow.setOption(option);
      window.addEventListener("resize", function () {
        myChartNow.resize();
      });
    },
    initBarChart(id, xData, yData) {
      const myChartNow = echarts.init(
        document.getElementById(id ? id : "bar-chart"),
        "",
        { devicePixelRatio: 2 }
      );
      const option = {
        tooltip: {
          show: false,
          trigger: "axis",
          axisPointer: {}
        },
        grid: {
          left: "0%",
          right: "18%",
          bottom: "-3%",
          top: "5%",
          containLabel: true
        },
        xAxis: {
          show: false
        },
        yAxis: [
          {
            type: "category",
            data: xData,
            inverse: true,
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              show: true,
              inside: true,
              textStyle: {
                color: "#101010",
                verticalAlign: "bottom",
                fontSize: 14,
                align: "left",
                fontFamily: "Metropolis",
                padding: [0, 0, 12, -7]
              }
            }
          }
        ],
        series: [
          {
            type: "bar",
            color: "#02B08E",
            data: yData,
            barWidth: 20,
            barGap: 20,
            itemStyle: {
              color: "#02B08E",
              border: "none",
              borderWidth: 3,
              barBorderRadius: 0
            },
            label: {
              show: true,
              position: "right",
              textStyle: {
                color: "#101010",
                fontSize: 14,
                align: "left",
                fontFamily: "Metropolis",
                padding: [0, 0, 0, 7]
              }
            }
          }
        ]
      };
      document
        .getElementById(id ? id : "bar-chart")
        .removeAttribute("_echarts_instance_");
      myChartNow.setOption(option);
      window.addEventListener("resize", function () {
        myChartNow.resize();
      });
    },
    initBarChartTwo(id, xData, yData) {
      const myChartNow = echarts.init(
        document.getElementById(id ? id : "bar-chartTwo"),
        "",
        { devicePixelRatio: 2 }
      );
      const option = {
        tooltip: {
          show: false,
          trigger: "axis",
          axisPointer: {}
        },
        grid: {
          left: "0%",
          right: "18%",
          bottom: "-3%",
          top: "5%",
          containLabel: true
        },
        xAxis: {
          show: false
        },
        yAxis: [
          {
            type: "category",
            data: xData,
            inverse: true,
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              show: true,
              inside: true,
              textStyle: {
                color: "#101010",
                verticalAlign: "bottom",
                fontSize: 14,
                align: "left",
                fontFamily: "Metropolis",
                padding: [0, 0, 12, -7]
              },
            },
          }
        ],
        series: [
          {
            type: "bar",
            color: "#02B08E",
            data: yData,
            barWidth: 20,
            itemStyle: {
              color: "#02B08E",
              border: "none",
              borderWidth: 3,
              barBorderRadius: 0
            },
            label: {
              show: true,
              position: "right",
              textStyle: {
                color: "#101010",
                fontSize: 14,
                align: "left",
                fontFamily: "Metropolis",
                padding: [0, 0, 0, 7]
              },
              formatter: function (data) {
                return `${data.value} ${data.value > 1 ? 'mins' : 'min'}`
              },
            }
          }
        ]
      };
      (document.getElementById(id ? id : "bar-schartTwo")).removeAttribute(
        "_echarts_instance_"
      );
      myChartNow.setOption(option);
      window.addEventListener("resize", function () {
        myChartNow.resize();
      });
    }
  },
  mounted() {
    this.initLineChart("line-chart", this.propertyPdfInfo.viewLineXData, this.propertyPdfInfo.viewLineYData);
    this.$nextTick(() => {
      if (this.propertyPdfInfo.tabBarXData.length) {
        this.initBarChart("bar-chart", this.propertyPdfInfo.tabBarXData, this.propertyPdfInfo.tabBarYData);
      }
      if (this.propertyPdfInfo.tabBarXData1.length) {
        this.initBarChartTwo("bar-chartTwo", this.propertyPdfInfo.tabBarXData1, this.propertyPdfInfo.tabBarYData1);
      }
    })
  }
};
</script>
<style lang="scss" scope>
.report-main {
  width: 1000px;
  background: #ffffff;
  border-radius: 0px 0px 0px 0px;
  position: fixed;
  z-index: -9999;

  .topBox {
    width: 1000px;
    height: 80px;
    background: #f5f5f5;
    border-radius: 0px 0px 0px 0px;
    display: flex;
    align-items: "center";
    padding: 10px 40px;

    .report-logo {
      width: 309px;
      height: 48px;
    }
  }

  .center-box {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .flex-box {
    display: flex;
  }

  .primaryText {
    font-family: Metropolis, Metropolis;
    font-weight: 400;
    font-size: 14px;
    color: #101010;
    text-align: left;
  }

  .report-content {
    padding: 40px;

    .pdf-tit {
      width: 100%;
      text-align: center;
      font-family: Metropolis-Semi Bold, Metropolis;
      font-weight: normal;
      font-size: 32px;
      color: #101010;
      line-height: 40px;
    }

    .pdf-time {
      font-family: Metropolis, Metropolis;
      font-weight: 400;
      font-size: 16px;
      color: #101010;
      line-height: 24px;
      margin: 5px 0 20px 0;
    }

    .lineBox {
      width: 100%;
      height: 1px;
      background: #101010;
      border-radius: 0px 0px 0px 0px;
      opacity: 0.1;
    }

    .property-infoBox {
      display: flex;

      .property-imgBox {
        width: 320px;
        min-width: 320px;
        height: 285px;
        border-radius: 10px 10px 10px 10px;
        background-color: #ccc;
        position: relative;

        .property-icon {
          position: absolute;
          top: 10px;
          left: 10px;
          width: auto;
          height: 30px;
          background: #101010;
        }
      }

      .property-info {
        margin-left: 40px;

        .property-type {
          font-family: Metropolis, Metropolis;
          font-weight: 400;
          font-size: 16px;
          color: #02B08E;
          line-height: 24px;
        }

        .addressText {
          width: 100%;
          word-break: break-word;
          font-family: Metropolis-Medium, Metropolis;
          font-weight: 500;
          font-size: 24px;
          color: #101010;
          line-height: 32px;
          margin: 5px 0;
        }

        .house-info {
          .housevalueBox {
            margin-bottom: 10px;
          }

          .label-box {
            width: 200px;
            min-width: 200px;
            color: #585858;
            margin-right: 20px;
            line-height: 20px;
          }

          .value-box {
            line-height: 20px;
            width: auto;
            word-break: break-word;
          }
        }
      }
    }

    .broker-list {
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      .broker-item {
        min-width: 280px;
        height: 124px;
        background: #f5f5f5;
        border-radius: 10px 10px 10px 10px;
        margin-bottom: 40px;
        padding: 20px;
        display: flex;

        &:nth-child(3n-1) {
          margin: 0 40px 40px 40px;
        }

        .userImg {
          width: 84px;
          height: 84px;
          border-radius: 100px 100px 100px 100px;
          border: 1px solid #ffffff;
          margin-right: 20px;
        }

        .user-icon {
          width: auto;
          height: 30px;
          // background: #101010;
        }

        .user-name {
          font-family: Metropolis-Medium, Metropolis;
          font-weight: 500;
          font-size: 16px;
          color: #101010;
          line-height: 24px;
          margin: 5px 0;
        }
      }
    }

    .statistics-list {
      display: flex;
      flex-wrap: wrap;

      .statistics-card {
        width: 200px;
        height: 108px;
        background: #ffffff;
        border-radius: 10px 10px 10px 10px;
        border: 1px solid rgba(0, 0, 0, 0.1);
        padding: 20px;
        margin: 0 40px 40px 0;

        &:nth-child(4n) {
          margin-right: 0px;
        }

        .sta-label {
          font-size: 16px;
        }

        .num-box {
          font-family: Metropolis-Semi Bold, Metropolis;
          font-weight: normal;
          font-size: 30px;
          color: #101010;
          line-height: 24px;
          margin-top: 20px;
        }
      }
    }

    .chart-tip {
      font-family: Metropolis-Medium, Metropolis;
      font-weight: 500;
      font-size: 16px;
      color: #101010;
      line-height: 24px;
      margin-bottom: 0px;
    }

    .line-chart {
      width: 920px;
      height: 334px;
      background: #ffffff;
      border-radius: 12px 12px 12px 12px;
      border: 1px solid rgba(0, 0, 0, 0.1);
      padding: 20px;

      #line-chart {
        width: 100%;
        height: 276px;
      }
    }

    .bar-box {
      width: 440px;
      // height: 489px;
      background: #ffffff;
      border-radius: 10px 10px 10px 10px;
      border: 1px solid rgba(0, 0, 0, 0.1);
      padding: 20px 20px 0 20px;

      #bar-chart,
      #bar-chartTwo {
        width: 100%;
        // height: 429px;
        min-height: 75px;
      }

      .empty-text {
        width: 100%;
        text-align: center;
        font-weight: 400;
        font-size: 14px;
        color: #101010;
        line-height: 20px;
        margin: 20px 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/listing/report.vue